function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m0 0v510h510v-510zm480 30v90h-450v-90zm-450 450v-330h450v330z"
}), React.createElement("path", {
  d: "m60 60h30v30h-30z"
}), React.createElement("path", {
  d: "m120 60h30v30h-30z"
}), React.createElement("path", {
  d: "m180 60h30v30h-30z"
}), React.createElement("path", {
  d: "m193.516 281.243c10.204-10.761 16.484-25.278 16.484-41.243 0-33.084-26.916-60-60-60s-60 26.916-60 60c0 15.965 6.28 30.482 16.484 41.243-27.695 15.363-46.484 44.905-46.484 78.757v90h180v-90c0-33.852-18.79-63.394-46.484-78.757zm-73.516-41.243c0-16.542 13.458-30 30-30s30 13.458 30 30-13.458 30-30 30-30-13.458-30-30zm90 180h-120v-60c0-33.084 26.916-60 60-60s60 26.916 60 60z"
}), React.createElement("path", {
  d: "m270 330h35.729l18.453 36.906 55.36-36.906h70.458v-150h-180zm30-120h120v90h-49.542l-34.641 23.094-11.546-23.094h-24.271z"
}), React.createElement("path", {
  d: "m330 240h60v30h-60z"
}));

var SvgReportUser = function SvgReportUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReportUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report_user.612a7dfe.svg";
export { ForwardRef as ReactComponent };